export const REDUCE_CLIENT_COMPANY_ELEMENT = 'REDUCE_CLIENT_COMPANY_ELEMENT';
export const REDUCE_CLIENT_COMPANY = 'REDUCE_CLIENT_COMPANY';
export const REDUCE_CLIENT_COMPANY_POLICIES = 'REDUCE_CLIENT_COMPANY_POLICIES';
export const GET_CLIENT_COMPANY = 'GET_CLIENT_COMPANY';
export const GET_CLIENT_COMPANY_POLICIES = 'GET_CLIENT_COMPANY_POLICIES';
export const UPDATE_CLIENT_COMPANY = 'UPDATE_CLIENT_COMPANY';
export const QUERY_CLIENT_COMPANIES = 'QUERY_CLIENT_COMPANIES';
export const EXECUTE_CLIENT_COMPANY_ACTION = 'EXECUTE_CLIENT_COMPANY_ACTION';
export const REDUCE_QUERY_ELEMENT = 'REDUCE_CLIENT_COMPANY_QUERY_ELEMENT';
export const REDUCE_CLIENT_COMPANIES = 'REDUCE_CLIENT_COMPANIES';
export const REDUCE_ENTITY = 'REDUCE_ENTITY';
export const REDUCE_PARAMETERS = 'REDUCE_PARAMETERS';
export const REDUCE_PARAMETER = 'REDUCE_PARAMETER';
